import { Spacer, Tag } from "@aircall/tractor";

interface KeysListProps {
  keys: (string | null)[];
}

export function KeysList({ keys }: KeysListProps) {
  return (
    <Spacer
      space="xxs"
      flexWrap="wrap"
      direction="horizontal"
      alignItems="start"
      data-test="call-context-key-topics-list"
    >
      {keys.map((key) => (
        <Tag key={key} mode="outline" variant="lightSecondary">
          {key}
        </Tag>
      ))}
    </Spacer>
  );
}
